import React, { useState, useEffect } from 'react';
import ImageListWeb from './imageListWeb';
import ImageListMobile from './imageListMobile';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const ImageListRouter = () => {
  const width = useWindowWidth();

  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <ImageListMobile /> : <ImageListWeb />;
};

export default ImageListRouter;
